export const CLOSED_LOST_THRESHOLD = 0;
export const OMIT_THRESHOLD = 5;
export const PIPELINE_THRESHOLD = 60;
export const BEST_CASE_THRESHOLD = 80;
export const COMMIT_THRESHOLD = 100;
export const CLOSED_WON_THRESHOLD = 100;